<template>
  <div v-if="resourceListBarOpt.visible" class="kg-resource-bar">
    <div class="bar-header">
      <span class="bar-title">资源列表</span>
      <i class="el-icon-close bar-close" @click="handleClose"></i>
    </div>
    <div class="bar-body" v-loading="loading">
      <div v-if="resourceList.length === 0 && !loading" class="bar-empty">暂无关联资源</div>
      <div
        v-for="item in resourceList"
        :key="item.id"
        class="resource-item"
        @click="handlePreview(item)"
      >
        <i :class="typeIcon(item.resourceType)"></i>
        <span class="resource-name">{{ item.resourceName || item.keyPoint || '未命名资源' }}</span>
      </div>
    </div>

    <!-- 文本预览 -->
    <el-dialog title="文本预览" :visible.sync="textPreviewVisible" width="600px" append-to-body>
      <div class="text-preview-content">{{ previewContent }}</div>
    </el-dialog>

    <!-- 文档预览 (Word/Excel/PPT) -->
    <el-dialog title="文档预览" :visible.sync="docPreviewVisible" width="90%" append-to-body @close="handleDocPreviewClose">
      <div v-loading="docPreviewLoading" style="min-height:400px;">
        <iframe
          v-if="previewUrl"
          ref="docPreviewIframe"
          :src="previewUrl"
          style="width:100%;height:70vh;border:none;"
          @load="handleIframeLoad"
        ></iframe>
      </div>
    </el-dialog>

    <!-- 图片预览 -->
    <el-dialog title="图片预览" :visible.sync="imagePreviewVisible" width="70%" append-to-body>
      <div class="image-preview-content">
        <img :src="previewUrl" style="max-width:100%;max-height:70vh;" />
      </div>
    </el-dialog>

    <!-- 视频预览 -->
    <el-dialog title="视频预览" :visible.sync="videoPreviewVisible" width="70%" append-to-body @close="handleVideoClose">
      <div class="video-preview-content">
        <video ref="previewVideo" :src="previewUrl" controls style="max-width:100%;max-height:70vh;"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { get as getResource } from '@/request/api/source.js'
import { getPreviewUrl } from '@/request/api/source.js'

export default {
  name: 'KgResourceListBar',
  inject: ['resourceListBarOpt'],
  data() {
    return {
      loading: false,
      resourceList: [],
      // 预览相关
      previewContent: '',
      previewUrl: '',
      textPreviewVisible: false,
      docPreviewVisible: false,
      docPreviewLoading: false,
      imagePreviewVisible: false,
      videoPreviewVisible: false,
      immAccessToken: '',
      immRefreshToken: '',
    }
  },
  watch: {
    'resourceListBarOpt.data': {
      handler(val) {
        this.buildResourceList(val || [])
      },
      deep: true,
    },
  },
  methods: {
    handleClose() {
      this.resourceListBarOpt.visible = false
      this.resourceListBarOpt.data = []
      this.resourceList = []
    },
    // 从 keypoint 列表构建资源列表，获取每个关联资源的详情
    async buildResourceList(keypointList) {
      console.log('[KgResourceListBar] buildResourceList called, keypointList:', keypointList.length, keypointList)
      if (!keypointList.length) {
        this.resourceList = []
        return
      }
      this.loading = true
      var result = []
      for (var i = 0; i < keypointList.length; i++) {
        var kp = keypointList[i]
        console.log('[KgResourceListBar] keypoint item:', kp.id, 'resourceId:', kp.resourceId)
        if (!kp.resourceId) continue
        try {
          var res = await getResource(kp.resourceId)
          if (res.code === 0 && res.data) {
            result.push({
              id: kp.id,
              resourceId: kp.resourceId,
              resourceName: res.data.name || kp.keyPoint,
              resourceType: res.data.type,
              resourceUri: res.data.resourceUri,
              content: res.data.content,
              keyPoint: kp.keyPoint,
            })
          }
        } catch (e) {
          console.error('获取资源详情失败:', e)
        }
      }
      this.resourceList = result
      this.loading = false
    },
    typeIcon(type) {
      var map = {
        1: 'el-icon-document',
        2: 'el-icon-link',
        3: 'el-icon-document',
        4: 'el-icon-s-grid',
        5: 'el-icon-data-line',
        6: 'el-icon-picture-outline',
        7: 'el-icon-video-camera',
      }
      return map[type] || 'el-icon-document'
    },
    handlePreview(item) {
      var type = item.resourceType
      var apiBaseURL = (window.apiUrl && window.apiUrl.baseURL) || process.env.VUE_APP_BASE_URL || ''
      var self = this

      switch (type) {
        case 1: // 文本
          this.previewContent = item.content || '暂无内容'
          this.textPreviewVisible = true
          break
        case 2: // 超链接
          if (item.resourceUri) {
            window.open(item.resourceUri, '_blank')
          } else {
            this.$message.warning('暂无链接地址')
          }
          break
        case 3: // Word
        case 4: // Excel
        case 5: // PPT
          if (item.resourceUri) {
            var resourceUrl = item.resourceUri.startsWith('http') ? item.resourceUri : (apiBaseURL + item.resourceUri)
            this.docPreviewVisible = true
            this.docPreviewLoading = true
            this.previewUrl = ''
            this.immAccessToken = ''
            this.immRefreshToken = ''

            getPreviewUrl(resourceUrl).then(function (data) {
              if (!data.previewUrl) {
                self.$message.error('预览地址为空')
                self.docPreviewVisible = false
                return
              }
              self.immAccessToken = data.accessToken
              self.immRefreshToken = data.refreshToken
              var finalUrl = data.previewUrl
              if (data.accessToken) {
                var separator = data.previewUrl.indexOf('?') >= 0 ? '&' : '?'
                finalUrl = data.previewUrl + separator + 'accessToken=' + data.accessToken
              }
              self.previewUrl = finalUrl
            }).catch(function (error) {
              console.error('预览接口错误:', error)
              self.$message.error(error.message || '获取预览凭证失败')
              self.docPreviewVisible = false
            }).finally(function () {
              self.docPreviewLoading = false
            })
          } else {
            this.$message.warning('暂无文件地址')
          }
          break
        case 6: // 图片
          if (item.resourceUri) {
            var imageUrl = item.resourceUri.startsWith('http') ? item.resourceUri : (apiBaseURL + item.resourceUri)
            this.previewUrl = imageUrl
            this.imagePreviewVisible = true
          } else {
            this.$message.warning('暂无图片地址')
          }
          break
        case 7: // 视频
          if (item.resourceUri) {
            var videoUrl = item.resourceUri.startsWith('http') ? item.resourceUri : (apiBaseURL + item.resourceUri)
            this.previewUrl = ''
            this.videoPreviewVisible = true
            setTimeout(function () {
              self.previewUrl = videoUrl
              self.$nextTick(function () {
                if (self.$refs.previewVideo) {
                  self.$refs.previewVideo.play().catch(function (err) {
                    console.log('自动播放失败:', err)
                  })
                }
              })
            }, 1000)
          } else {
            this.$message.warning('暂无视频地址')
          }
          break
        default:
          this.$message.warning('未知资源类型')
      }
    },
    handleVideoClose() {
      if (this.$refs.previewVideo) {
        this.$refs.previewVideo.pause()
      }
    },
    handleDocPreviewClose() {
      this.previewUrl = ''
      this.immAccessToken = ''
      this.immRefreshToken = ''
      window.removeEventListener('message', this.handleImmMessage)
    },
    handleImmMessage(event) {
      if (event.data && (event.data.type === 'getAccessToken' || event.data === 'getAccessToken')) {
        if (this.$refs.docPreviewIframe && this.immAccessToken) {
          this.$refs.docPreviewIframe.contentWindow.postMessage({
            type: 'setAccessToken',
            data: {
              accessToken: this.immAccessToken,
              refreshToken: this.immRefreshToken,
            },
          }, '*')
        }
      }
    },
    handleIframeLoad() {
      var self = this
      window.addEventListener('message', this.handleImmMessage)
      if (this.$refs.docPreviewIframe && this.immAccessToken) {
        setTimeout(function () {
          self.$refs.docPreviewIframe.contentWindow.postMessage({
            type: 'setAccessToken',
            data: {
              accessToken: self.immAccessToken,
              refreshToken: self.immRefreshToken,
            },
          }, '*')
        }, 100)
      }
    },
  },
}
</script>

<style scoped lang="less">
.kg-resource-bar {
  position: absolute;
  right: 320px;
  top: 10px;
  width: 280px;
  max-height: calc(100vh - 40px);
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  z-index: 100;
  display: flex;
  flex-direction: column;
}
.bar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #ebeef5;
}
.bar-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}
.bar-close {
  cursor: pointer;
  color: #909399;
  font-size: 16px;
  &:hover {
    color: #303133;
  }
}
.bar-body {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}
.bar-empty {
  text-align: center;
  color: #909399;
  padding: 20px 0;
  font-size: 13px;
}
.resource-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #f5f7fa;
  }
  i {
    margin-right: 8px;
    color: #409eff;
    font-size: 16px;
  }
}
.resource-name {
  font-size: 13px;
  color: #409eff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-preview-content {
  max-height: 400px;
  overflow-y: auto;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 1.6;
}
.image-preview-content,
.video-preview-content {
  text-align: center;
}
</style>
